export const ssoError = {
  signUpEmailAlreadyExist: "An account with this email exists. Please <2>sign in</2>.",
  signIn: "sign in",
  signUp: "sign up",
  signInEmailDoesntExistTitle: "Please try another email, or <1>sign up</1>.",
  signInAppleEmailDoesntExistMessage: "Your Apple ID isn't connected to a Fullscript account.",
  signInGoogleEmailDoesntExistMessage: "Your Google email isn't connected to a Fullscript account.",
  officeSignUpWrongEmailWithEmailTitle: "The email {{ssoEmail}} hasn't received an invitation.",
  officeSignUpWrongEmailMessage:
    "To join the dispensary, you must use the same email address from your invite.",
  rxSignInWrongEmail: "The email you selected is not associated with this {{ treatmentPlanTerm }}.",
  invalidEmailLink: "This link is invalid. Click on the link in the email to try again.",
  appleAccountCantConnectHeader: "Unable to connect Apple account",
  appleAccountCantConnectMessage: "Please use your email and password to sign in.",
  authenticationFailed: "Something went wrong. Please try again or use your email to continue.",
};
